import { GzInputFileWebComponent } from './component/GzInputFileWebComponent';
import { WEB_COMPONENT_GZ_INPUT_FILE } from '../../webcomponents.constants';

export { GzInputFileWebComponent };

window.customElements.define(WEB_COMPONENT_GZ_INPUT_FILE, GzInputFileWebComponent);
